import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ButtonComponent, DatalayerService, NotificationType } from '@woolworthsnz/styleguide';
import { RecipeSearchRequest } from '@woolworthsnz/trader-api';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';

@Component({
	selector: 'recipe-nutritional-info',
	templateUrl: './nutritional-info.component.html',
	styleUrls: ['./nutritional-info.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgFor, ButtonComponent, RouterLink]
})
export class NutritionalInfoComponent {
	@Input() nutritionalTags: string;

	public tagsSearchTarget: RecipeSearchRequest.TargetEnum = 'Tags';

	constructor(private datalayerService: DatalayerService) { }

	get nutritionalTagsList(): string[] {
		return this.nutritionalTags?.split(',').map((tag) => tag.trim()) || [];
	}

	public handleTagClick(tag: string): void {
		this.datalayerService.trackRecipeEvent(NotificationType.Button, `RDP_nutritional_${tag.toLowerCase()}`);
	}
}
